export default __webpack_public_path__ + "static/media/foodprefference.8a5d4fde.png";